module.exports = __webpack_public_path__ + "img/home-icon-01.ee16e912.png";